import { SvgIcon, SvgIconProps } from '@mui/material';

const Success = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 16, height: 16, fill: 'none', ...sx }}
      data-testid="successIcon"
      titleAccess="passed"
      {...props}
    >
      <path
        d="M1.52645 7.33445C1.26853 7.60174 1.26853 8.02413 1.52645 8.29141L6.12589 13.058C6.19411 13.1287 6.30769 13.1287 6.37592 13.058L14.4729 4.66678C14.7308 4.3995 14.7308 3.97711 14.4729 3.70982L13.4565 2.65644C13.1836 2.37364 12.7292 2.37364 12.4563 2.65644L6.37592 8.9578C6.30769 9.0285 6.19411 9.0285 6.12589 8.9578L3.54301 6.28107C3.27012 5.99827 2.81578 5.99827 2.5429 6.28107L1.52645 7.33445Z"
        fill="#25AE6C"
      />
    </SvgIcon>
  );
};

export default Success;
